import {userLogout} from '../api/Api';
import Cookies from 'js-cookie';
import {UserOutlined} from '@ant-design/icons';

export const Logout = ({onLogout}) => {
    const onClick = () => {
        userLogout().then(r => {
            console.log(`userLogout complete`);
        }).catch(e => {}).finally(() => {
            console.log(`removing cookie`);
            Cookies.remove('sessionId');
            onLogout();
        });
    }
    return <div onClick={onClick} style={{cursor: 'pointer'}}><UserOutlined style={{color: '#1677ff'}}/>Logout</div>
}